/**
 * Coordinates the pieces of a direct-auth session: key derivation (httpsig),
 * the in-memory Signer singleton (session), and the serializable Redux snapshot
 * (auth-session-slice). The login derives the identity first, probes the agent,
 * and only marks the session unlocked once the agent accepts it. See this.i
 * wqz7k3mnbp.
 */

import type {AppDispatch} from '@/store';
import {deriveIdentity} from './httpsig';
import {setIdentity, clearIdentity} from './session';
import {lock, unlock} from '@/store/auth-session/auth-session-slice';

/**
 * Derive the identity from a passcode and store it in memory so requests can be
 * signed (including the connectivity probe). Does NOT mark the Redux session
 * unlocked — call markSessionUnlocked once the agent has accepted the identity.
 * Returns the derived non-transferable AID; throws on an invalid passcode.
 */
export async function prepareIdentity(passcode: string): Promise<string> {
  const identity = await deriveIdentity(passcode);
  setIdentity(identity);
  return identity.aid;
}

/** Mark the session unlocked (lets the SessionGuard into the app). */
export function markSessionUnlocked(aid: string, dispatch: AppDispatch): void {
  dispatch(unlock({aid}));
}

/** Clear the in-memory identity and mark the session locked. */
export function endSession(dispatch: AppDispatch): void {
  clearIdentity();
  dispatch(lock());
}
